<style scoped>
.title-block {
    text-align: center;
    padding: 20px;
    width: 100%;
    float: right;
    position: absolute;
    right: 0;
    z-index: -1;
}
</style>

<template>
<div id="in_az_app">
    <div class="header">
        <div class="title-block">
            <div class="title">
                {{GroupName}}
            </div>
        </div>
        <div>
        <span class="button-block">
            <router-link :to="{ name: 'groups-list'}" data-toggle="tooltip" title="Группы">
                <div class="icon list-icon"></div>
            </router-link>
            <router-link :to="{ name: 'user-cabinet'}" data-toggle="tooltip" title="Настройки пользователя">
                <div class="icon user-icon"></div>
            </router-link>
            <a class="logout" @click="logout" data-toggle="tooltip" title="Выход">
            <div></div>
            </a>
        </span>
        </div>
    </div>
    <div class="content-block">
        <div class="container app-container">
            <div class="row">
                <group-menu-component :page="page_name"></group-menu-component>
                <router-view></router-view>
            </div>
        </div>
    </div>
    <div class="footer">
        <div>
            <span>© AuqaZor, 2019</span>
        </div>
        <div>
            <span style="right: 0">Техподдержка:
                <a href="mailto:support@aquazor.ru">support@aquazor.ru</a>
                <a href="tel:+74951202269">+7(495) 120-22-69</a>
            </span>
        </div>
    </div>
</div>
</template>

<script>
import '@/assets/css/main.css'
import '@/assets/css/inmain.css'
import '@/assets/css/icons.css'
import auth from '@/auth.js'
import axios from 'axios'
import config from '@/config.js'
import GroupMenu from '@/components/elements/group_menu.vue'
import {
    store
} from '@/store'

export default {
    created() {
        var html_elements = document.getElementsByTagName('html');
        for (var i = 0; i < html_elements.length; i++) {
            html_elements[i].className = "in_main";
        }
        this.get_group_name()
        this.$eventHub.$on('LayoutGroupNameEvent', this.changeHeadName)
        this.$store.commit('SET_ID_GROUP', this.$route.params.id_group)
    },
    data() {
        return {
            group_name: '',
            id_group: this.$route.params.id_group,
            page_name: ''
        }
    },
    methods: {
        logout() {
            auth.logout((result) => {
                if (result) {
                    this.$router.replace('/')
                }
            })
        },
        changeHeadName(name_for_group) {
            this.group_name = name_for_group
        },
        get_group_name() {
            if (!!localStorage.token) {
                var post_data = new FormData()
                post_data.set('token', localStorage.token)
                post_data.set('id_group', this.$route.params.id_group)
                var vue_obj = this
                axios({
                        method: 'POST',
                        url: config.API_HOST + '/groups/group_name',
                        data: post_data
                    })
                    .then(function (response) {
                        vue_obj.group_name = response.data.name
                    })
                    .catch(function (error) {
                        if (error.response.status == 404) {
                           vue_obj.$router.push({ path: '/groups-list'})
                        }
                    })
            }
        }
    },
    components: {
        'group-menu-component': GroupMenu
    },
    beforeUpdate() {
        this.page_name = this.$route.name
    },
    computed: {
        GroupName: function () {
            return this.group_name
        }
    },
    destroyed() {
        this.$store.commit('SET_ID_GROUP', false)
    }
}
</script>



// WEBPACK FOOTER //
// src/layouts/GroupLayout.vue